import { makeStyles, css, theme } from '@conexasaude/hero'

const useStyles = makeStyles({
  confirmDataSection: () => css`
    .scheduled-section {
      div {
        display: flex;
        margin-bottom: 8px;
      }
      svg {
        margin-right: 10px;
      }
      span {
        font-weight: 600;
        color: ${theme.colors.neutral[900]};
      }
    }
  `,
})

export default useStyles
